module.exports = __webpack_public_path__ + "img/کارت-ویزیت-سلفون-مخملی.2424e055.png";